import { IPodDesign } from '../../contracts/pod-design.interface';
import { EnumPlatform } from '../../contracts/print-on-demand.constants';


/**------------------------------------------------------
 * Interface Definitions
 */
export interface IAbstractStatus {
	warnings	: string[];
	errors		: string[];
}

export interface IPlatformStatus extends IAbstractStatus {
	code		: EnumPlatform;		// platform code like for displate', ...
	warnings	: string[];
	errors		: string[];
}

export interface IListingCheck {
	isListingEmpty(data: IPodDesign): boolean;
	checkListing(data: IPodDesign)  : IPlatformStatus[] | IPlatformStatus;
}


/**------------------------------------------------------
 * Constants & Configurations
 */
export const PLACEHOLDERS: string[] = ['xxxx', '[xxxx]', '[brand]', '[title]', '[bullet1]', '[bullet2]', '[desc]', '[description]', '[kw]', '[keyword]'];
